// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39vru","col":"styles_col__5k9sC","fulfillmentStatus":"styles_fulfillmentStatus__1c-WI","emailCol":"styles_emailCol__2JdbV"};